//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        goDetail () {
            this.$emit('goDetail')
        }
    },
    computed: {
        date () {
            return this.predict_time && this.predict_time.substring(0, 11)
        },
        time () {
            return this.predict_time && this.predict_time.substring(11)
        }
    },
    props: {
        predict_time: {
            type: String
        },
        predict_registers: {
            type: Number
        },
        register_predict_precision: {
            type: Number
        }
    }
}
